import { useLayoutEffect, useRef } from 'react';
import type { TLatest } from './useLatest.types.ts';

export const useLatest = <TValue>(value: TValue): TLatest<TValue> => {
  const latest = useRef(value);

  useLayoutEffect(() => {
    latest.current = value;
  }, [value]);

  return latest;
};
